/**
 * International Pricing Hide
 * Hides pricing for customers outside the United States when enabled in theme settings
 * Uses the same getUserLocale API as deeplinks for accurate geolocation
 * 
 * To manually test: Run in console: window.testInternationalPricing('GB')
 */

(function() {
  'use strict';
  
  // Check if the feature is enabled via theme settings
  const hideInternationalPricing = document.documentElement.dataset.hideInternationalPricing === 'true';
  
  if (!hideInternationalPricing) {
    return; // Feature is disabled, do nothing
  }
  
  // Check for manual test override in sessionStorage
  const testCountry = sessionStorage.getItem('test_country_override');
  if (testCountry) {
    const userCountry = testCountry.toUpperCase();
    
    if (userCountry !== 'US') {
      document.documentElement.classList.add('hide-international-pricing');
    }
    return;
  }
  
  // Fetch user's country from getUserLocale API (same as deeplinks)
  fetch('https://alpine-hosports.herokuapp.com/getUserLocale')
    .then(response => response.json())
    .then(locale => {
      if (locale && locale.geo && locale.geo.country) {
        const userCountry = locale.geo.country.toUpperCase();
        
        // If user is outside the US, add class to hide pricing
        if (userCountry !== 'US') {
          document.documentElement.classList.add('hide-international-pricing');
        }
      }
    })
    .catch(error => {
      // Error fetching location - show prices as safe default
    });
})();

// Global test function for manual testing
window.testInternationalPricing = function(countryCode) {
  sessionStorage.setItem('test_country_override', countryCode);
  location.reload();
};

